module.exports = __webpack_public_path__ + "static/media/o-home-about-img.95c0c0b9.png";